import React from 'react'
import { Bin, Edit } from '../../atoms/NewIcons'
import { Trans } from '../..'
import FormCheckbox from '../../atoms/FormCheckbox/FormCheckbox'
import FormRadio from '../../atoms/FormRadio/FormRadio'

const IndirizzoCard = ({
  variant,
  indirizzo,
  onEdit,
  onDelete,
  changePreferenziale,
  isSelected,
  setSelected,
  noBackground = false,
  selectable = false,
}) => {
  const IndirizzoCardButton = ({ icon, label, onClick }) => {
    return (
      <div className="indirizzo-card__button" onClick={onClick}>
        <span className="indirizzo-card__button-icon">{icon}</span>
        <span className="indirizzo-card__button-label">{label}</span>
      </div>
    )
  }

  const Wrapper = ({ children }) =>
    selectable ? (
      <div className={'indirizzo-card__option'}>
        <FormRadio size="md" checked={isSelected} onClick={() => setSelected(indirizzo.id)} />
        <div>{children}</div>
      </div>
    ) : (
      <>{children}</>
    )

  return (
    <div
      className={`indirizzo-card ${variant === 'checkout' ? 'indirizzo-card--checkout' : ''} ${
        noBackground ? 'indirizzo-card--no-bg' : ''
      }`}
    >
      <Wrapper>
        <div className="indirizzo-card__header">
          {indirizzo.ragione_sociale ? (
            <p className="indirizzo-card__title">{indirizzo.ragione_sociale}</p>
          ) : (
            <p className="indirizzo-card__title">
              {indirizzo.nome} {indirizzo.cognome}
            </p>
          )}
          {variant !== 'checkout' && !indirizzo.is_sede && (
            <div className="indirizzo-card__buttons">
              <IndirizzoCardButton
                icon={<Edit />}
                label={<Trans chiave="Modifica" />}
                onClick={() => onEdit(indirizzo)}
              />
              <IndirizzoCardButton
                icon={<Bin />}
                label={<Trans chiave="Rimuovi" />}
                onClick={() => onDelete(indirizzo.id)}
              />
            </div>
          )}
        </div>
        <div className="indirizzo-card__description">
          {variant === 'checkout' ? (
            <p>
              {indirizzo.indirizzo +
                ' ' +
                indirizzo.citta +
                ' ' +
                indirizzo.cap +
                ' ' +
                indirizzo.nazione?.nome}
            </p>
          ) : (
            <>
              <p>{indirizzo.indirizzo}</p>
              <p>
                {indirizzo.citta}, {indirizzo.cap}
              </p>
              <p>{indirizzo.nazione.nome}</p>
              <p>{indirizzo.telefono}</p>
            </>
          )}
        </div>
        <div className="indirizzo-card__footer">
          {/*
        <div className="indirizzo-card__footer__checkbox">
          <FormCheckbox label={"Usa come indirizzo di fatturazione"} checked={indirizzo?.fatturazione} readOnly />
        </div>
        */}
          {variant !== 'checkout' && !indirizzo.is_sede && (
            <div className="indirizzo-card__footer__checkbox">
              <FormCheckbox
                label={<Trans chiave="Usa come indirizzo predefinito" />}
                checked={indirizzo?.preferenziale}
                onChange={(e) => changePreferenziale(e.target.checked, indirizzo)}
              />
            </div>
          )}
          {variant === 'checkout' && !indirizzo.is_sede && (
            <div className="indirizzo-card__buttons">
              {onEdit && (
                <IndirizzoCardButton
                  icon={<Edit />}
                  label={<Trans chiave="Modifica" />}
                  onClick={() => onEdit(indirizzo)}
                />
              )}
              {onDelete && (
                <IndirizzoCardButton
                  icon={<Bin />}
                  label={<Trans chiave="Rimuovi" />}
                  onClick={() => onDelete(indirizzo.id)}
                />
              )}
            </div>
          )}
        </div>
      </Wrapper>
    </div>
  )
}

export default IndirizzoCard
